export const CREATE_ALERT_SUCCESS = "CREATE_ALERT_SUCCESS"
export const CREATE_ALERT_ERRORS = "CREATE_ALERT_ERRORS"
